import React, {Component} from 'react';
import './PlanItemDialog.css';
import RmDialog from "./RmDialog";
import PropTypes from 'prop-types';
import RmButton from "../../Common/RmButton";
import axios from 'axios';
import ErrorMessage from "../../Common/ErrorMessage";

export default class PlanItemDeleteDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            task: null,
            busyDeleting: false,
            errorMessage: null
        };
    }

    componentWillReceiveProps(nextProps) {
        let taskId = null;

        if (nextProps.task) {
            taskId = nextProps.task.id;
        }

        if ((!this.state.task && nextProps.task) || (this.state.task && taskId !== this.state.task.id)) {
            this.refreshTaskState(nextProps.task);
        }
    }

    componentDidMount() {
        this.refreshTaskState(this.props.task);
    }

    refreshTaskState(taskFromProps) {
        let task = taskFromProps || {};

        this.setState({
            task: task,
            busyDeleting: false,
            errorMessage: null
        });
    }

    handleCloseClick() {
        if (this.state.busyDeleting) {
            return;
        }

        this.props.onCancel();
    }

    handleDeleteClick() {
        if (this.state.busyDeleting) {
            return;
        }

        this.setState({
            busyDeleting: true,
            errorMessage: null
        });

        axios.delete(`/tasks/${this.state.task.id}`)
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    this.props.onComplete();
                } else {
                    // Valid response but not OK, usually validation problem
                    let errorMessage = "De taak kon niet verwijderd worden.";

                    if (data.message) {
                        errorMessage = data.message;
                    }

                    this.setState({
                        errorMessage: errorMessage
                    });
                }
            })
            .catch((err) => {
                console.error('Plan item delete confirm dialog, DELETE fail', err);

                this.setState({
                    errorMessage: "De taak kon niet verwijderd worden."
                });
            })
            .then(() => {
                this.setState({
                    busyDeleting: false
                });
            });
    }

    render() {
        if (!this.props.visible) {
            return (null);
        }
        
        let busy = !!this.state.busyDeleting;

        return (
            <RmDialog title={"Taak verwijderen"} subtitle={this.props.task.name} onCloseRequested={this.handleCloseClick.bind(this)}
                      canClose={!busy}
            >
                <div className={"PlanItemDialog"}>
                    <div className={"PlanItemDialog__text"}>
                        <p>Weet je zeker dat je deze taak wil verwijderen uit het draaiboek?</p>
                    </div>
                    <div className={"PlanItemDialog__controls"}>
                        {this.state.errorMessage && <ErrorMessage message={this.state.errorMessage}/>}
                        <div className={"PlanItemDialog__controls-row"}>
                            <RmButton label={"Verwijderen"} onClick={this.handleDeleteClick.bind(this, false)}
                                      busy={busy}
                            />
                        </div>
                    </div>
                </div>
            </RmDialog>
        );
    }
}

PlanItemDeleteDialog.propTypes = {
    task: PropTypes.object,
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/Portal/Dialog/PlanItemDeleteDialog.js